/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.5 4C14.5 5.38071 13.3807 6.5 12 6.5C10.6193 6.5 9.5 5.38071 9.5 4C9.5 2.61929 10.6193 1.5 12 1.5C13.3807 1.5 14.5 2.61929 14.5 4ZM16 4C16 6.20914 14.2091 8 12 8C9.79086 8 8 6.20914 8 4C8 1.79086 9.79086 0 12 0C14.2091 0 16 1.79086 16 4ZM6.5 20C6.5 21.3807 5.38071 22.5 4 22.5C2.61929 22.5 1.5 21.3807 1.5 20C1.5 18.6193 2.61929 17.5 4 17.5C5.38071 17.5 6.5 18.6193 6.5 20ZM8 20C8 22.2091 6.20914 24 4 24C1.79086 24 0 22.2091 0 20C0 17.7909 1.79086 16 4 16C6.20914 16 8 17.7909 8 20ZM12 8.75C12.4142 8.75 12.75 9.08579 12.75 9.5V13.625L15.95 16.025C16.2814 16.2735 16.3485 16.7436 16.1 17.075C15.8515 17.4064 15.3814 17.4735 15.05 17.225L12 14.9375L8.95 17.225C8.61863 17.4735 8.14853 17.4064 7.9 17.075C7.65147 16.7436 7.71863 16.2735 8.05 16.025L11.25 13.625V9.5C11.25 9.08579 11.5858 8.75 12 8.75ZM22.5 20C22.5 21.3807 21.3807 22.5 20 22.5C18.6193 22.5 17.5 21.3807 17.5 20C17.5 18.6193 18.6193 17.5 20 17.5C21.3807 17.5 22.5 18.6193 22.5 20ZM24 20C24 22.2091 22.2091 24 20 24C17.7909 24 16 22.2091 16 20C16 17.7909 17.7909 16 20 16C22.2091 16 24 17.7909 24 20Z"
    fill="currentColor"
  />,
  'MenuThirdParty'
);
